import iconWithdraw from '../assets/images/iconWithdraw.png';
import iconError from '../assets/images/shape.svg';
import VerifyPhoneNow from '../assets/images/VerifyPhoneNow.svg';

export const IMAGE = {
  ICON_WITHDRAW_EMPTY: iconWithdraw,
  ICON_ERROR: iconError,
  VERIFY_PHONE: VerifyPhoneNow
};
